import React from "react";
import { Crown } from "./CrownIcon";

export const Footer = () => {
    return (
        <footer
            data-testid="footer"
            className="relative border-t-4 border-kickgreen mt-10 pt-10 pb-8 bg-black"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
                <div>
                    <div className="flex items-center gap-3 mb-3">
                        <Crown className="w-10 h-8" color="#FF2E93" />
                        <span className="font-anton uppercase text-2xl text-white tracking-tight">
                            Get Saved Bro
                        </span>
                    </div>
                    <p className="font-graffiti text-skyblue text-xl -rotate-2">
                        @leonardthepreacher
                    </p>
                    <p className="font-chivo text-white/50 text-xs mt-3 max-w-sm">
                        Street ministry, midnight sermons, daily testimony.
                    </p>
                </div>

                <div>
                    <h4 className="font-anton uppercase tracking-widest text-xs text-white/60 mb-3">
                        Where to Watch
                    </h4>
                    <ul className="space-y-2 font-chivo text-sm">
                        <li>
                            <a
                                href="https://kick.com/leonardthepreacher"
                                target="_blank"
                                rel="noreferrer"
                                className="text-white hover:text-kickgreen transition-colors"
                            >
                                kick.com/leonardthepreacher
                            </a>
                        </li>
                        <li className="text-white/60">Daily · 12:00 AM EST</li>
                        <li>
                            <a
                                data-testid="footer-tip-link"
                                href="https://buymeacoffee.com/leonardthepreacher"
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-1 text-hotpink hover:text-white font-bold"
                            >
                                ☕ Send a Tip
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-anton uppercase tracking-widest text-xs text-white/60 mb-3">
                        Connect
                    </h4>
                    <ul className="space-y-2 font-chivo text-sm">
                        <li>
                            <a
                                href="https://instagram.com/leonardthepreacher1"
                                target="_blank"
                                rel="noreferrer"
                                className="text-white hover:text-hotpink"
                            >
                                Instagram
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://threads.net/@leonardthepreacher1"
                                target="_blank"
                                rel="noreferrer"
                                className="text-white hover:text-skyblue"
                            >
                                Threads
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://tiktok.com/@leonardthepreacher"
                                target="_blank"
                                rel="noreferrer"
                                className="text-white hover:text-kickgreen"
                            >
                                TikTok
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t-2 border-white/10 flex flex-wrap items-center justify-between gap-2">
                <span className="font-chivo text-xs text-white/40">
                    © {new Date().getFullYear()} Leonard The Preacher · All glory given.
                </span>
                <a
                    data-testid="footer-admin-link"
                    href="/admin"
                    className="font-anton uppercase text-xs tracking-widest text-white/40 hover:text-kickgreen"
                >
                    Admin
                </a>
            </div>
        </footer>
    );
};
